import {createContext} from 'react';

export type DialogContextType = {
    onClose?: () => void,
};
export const DialogContext = createContext<DialogContextType>({});

DialogContext.displayName = 'DialogContext';
